import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { RouletteGridConfiguration } from "../../CustomComponents/RouletteGridConfiguration";
import { RouletteBetConfiguration } from "../../CustomComponents/RouletteBetConfiguration";
import { RouletteActions } from "../../Channels/Common/Actions/RouletteActions";
import { HtmlRouletteTableElement } from "./HtmlRouletteTableElement";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { BaseElement } from "../../Components/Elements/Graphics/BaseElement";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlGridSingleBetsElement extends HtmlRouletteTableElement {
    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(
        parentId: string,
        id: string,
        className: string,
        gridBets: { [id: string]: SwitchElement },
        canvasElement: BaseElement,
        width: number,
        height: number,
    ) {
        super(parentId, id, className, canvasElement, width, height);

        this.createRacetrackBackBtn();
        this.createGridBets(gridBets);
    }

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    private createRacetrackBackBtn(): void {
        if (window["CHANNEL"] == "mobile") {
            const racetrackOff = this.createHtmlButton(RouletteActions.ActionRacetrackOff);
            racetrackOff.instance.classList.add("racetrackOffBtn");

            this.instance.appendChild(racetrackOff.instance);
        }
    }

    private createGridBets(gridBets: { [id: string]: SwitchElement }): void {
        if (gridBets != null) {
            let i: number;
            let w: number;
            let h: number;
            let actionId: string;
            let elem: SwitchElement;

            //single
            for (i = 0; i < RouletteBetConfiguration.Single.length; i++) {
                actionId = RouletteActions.ActionBetSingle + RouletteBetConfiguration.Single[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    w = RouletteGridConfiguration.numberWidth;
                    h = RouletteGridConfiguration.numberHeight;

                    if (i == 0) {
                        w = RouletteGridConfiguration.zeroWidth;
                        h = RouletteGridConfiguration.zeroHeight;
                    }

                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h, "true");
                }
            }

            //column
            for (i = 0; i < RouletteBetConfiguration.Column.length; i++) {
                actionId = RouletteActions.ActionBetColumn + RouletteBetConfiguration.Column[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    w = RouletteGridConfiguration.columnWidth;
                    h = RouletteGridConfiguration.columnHeight;

                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h);
                }
            }

            //dozen
            for (i = 0; i < RouletteBetConfiguration.Dozen.length; i++) {
                actionId = RouletteActions.ActionBetDozen + RouletteBetConfiguration.Dozen[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    w = RouletteGridConfiguration.dozenWidth;
                    h = RouletteGridConfiguration.dozenHeight;

                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h);
                }
            }

            w = RouletteGridConfiguration.pairedWidth;
            h = RouletteGridConfiguration.pairedHeight;

            //red-black
            for (i = 0; i < RouletteBetConfiguration.RedOrBlack.length; i++) {
                actionId = RouletteActions.ActionBetRedOrBlack + RouletteBetConfiguration.RedOrBlack[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h);
                }
            }

            //odd-even
            for (i = 0; i < RouletteBetConfiguration.EvenOrOdd.length; i++) {
                actionId = RouletteActions.ActionBetEvenOrOdd + RouletteBetConfiguration.EvenOrOdd[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h);
                }
            }

            //low-high
            for (i = 0; i < RouletteBetConfiguration.LowOrHigh.length; i++) {
                actionId = RouletteActions.ActionBetLowOrHigh + RouletteBetConfiguration.LowOrHigh[i];
                elem = gridBets[actionId];

                if (elem != null) {
                    this.generateHtmlGridBet(this.instance, elem, actionId, w, h);
                }
            }
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private generateHtmlGridBet(
        holder: HTMLElement,
        gridBet: SwitchElement,
        actionId: string,
        width: number,
        height: number,
        showMagnifier: string = "false",
    ): void {
        let betType = actionId.split("_");
        let x: number = gridBet.position.x - Math.round(width * 0.5);
        let y: number = gridBet.position.y - Math.round(height * 0.5);

        let betHtmlPlace = this.createHtmlButton(actionId);
        this.setupHtmlElement(betHtmlPlace.instance, x, y, width, height);

        betHtmlPlace.instance.setAttribute("id", actionId);
        betHtmlPlace.instance.setAttribute("data-magnifier", showMagnifier);

        if (window["CHANNEL"] == "mobile") {
            const self = this;
            betHtmlPlace.instance.addEventListener("touchstart", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchStart(event, betType[0], betType[1], false);
            });

            betHtmlPlace.instance.addEventListener("touchmove", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchMove(event, false);
            });

            betHtmlPlace.instance.addEventListener("touchend", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchEnd(event, false);
            });
        } else {
            betHtmlPlace.instance.addEventListener(
                "mouseover",
                this.onHtmlBetPlaceMouseOver.bind(this, betType[0], betType[1], false),
            );
            betHtmlPlace.instance.addEventListener(
                "mouseout",
                this.onHtmlBetPlaceMouseOut.bind(this, betType[0], betType[1], false),
            );
        }

        holder.appendChild(betHtmlPlace.instance);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlGridSingleBetsElement.ts
 **/